import { render, staticRenderFns } from "./BloodCheckup.vue?vue&type=template&id=675fc288&scoped=true"
import script from "./BloodCheckup.vue?vue&type=script&lang=js"
export * from "./BloodCheckup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675fc288",
  null
  
)

export default component.exports